import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "./pages/notFound/NotFound";
import Loading from "./pages/loading/Loading";
import PrivatRouts from "./components/PrivatRouts";
import Login from "./pages/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import BrandBook from "./pages/brandBook/BrandBook";
import Files from "./pages/files/Files";
import News from "./pages/news/News";
import Elements from "./pages/settings/elements/Elements";
import Sections from "./pages/settings/sections/Sections";
import Equipment from "./pages/settings/equipment/Equipment";
import Instruction from "./pages/instruction/Instruction";
import FilesCreate from "./pages/filesCreate/FilesCreate";
import CreateIframe from "./pages/createIFrame/CreateIframe";
import EditIFrame from "./pages/editIFrame/EditIFrame";

const Rotes = () => {
    return (
        <Routes>
            <Route exact path="*" element={<NotFound />} />
            {/* <Route exact path="/" element={<Loading />} /> */}
            <Route exact path="/" element={<Login />} />
            <Route element={<PrivatRouts />}>
                <Route exact path="/dashboard" element={<Dashboard />} />
                <Route exact path="/brandbook" element={<BrandBook />} />
                <Route exact path="/files" element={<Files />} />
                {/* <Route exact path="/files/create" element={<FilesCreate />} /> */}
                <Route exact path="/files/create" element={<CreateIframe />} />
                {/* <Route exact path="/files/create/:id" element={<CreateIframe />} /> */}
                <Route exact path="/files/edit/:id" element={<EditIFrame />} />
                <Route exact path="/news" element={<News />} />
                <Route exact path="/elements" element={<Elements />} />
                <Route exact path="/sections" element={<Sections />} />
                <Route exact path="/equipment" element={<Equipment />} />
                <Route exact path="/instruction" element={<Instruction />} />
            </Route>
        </Routes>
    );
};

export default Rotes;
